import { Component, OnInit, Input } from '@angular/core';
import { PortfolioCategory } from './../models/Portfolio';
import { ActivatedRoute } from '@angular/router';
import { PortfolioService } from '../portfolio.service';
// import { Location } from '@angular/common';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css'],
})
export class PortfolioComponent implements OnInit {

  @Input() itemCount: number = 0;
  @Input() showText: boolean = false;
  @Input() source: string = '';
  @Input() id: number = 0;
  
  showNavigationArrows = true;
  showNavigationIndicators = false;

  portfolioCats: PortfolioCategory[];
  //  = [
  //   { id: 1, name: 'Renovation', image: '005a', text: 'A while ago, this oast was a derelict farm building. Now it has been sympathetically restored to a high standard, including oak joinery and working cowl, for a demanding client.' },
  //   { id: 2, name: 'Extension', image: '010a', text: 'An old conservatory has been replaced with this spectacular family room with exposed oak trusses and glazed gable end, opening onto and lighting up a refurbished kitchen area.'  },
  //   { id: 3, name: 'Kitchens', image: '2_4', text: 'We can arrange the full design and installation of kitchens or work with the client’s installer. We will work to the highest standards as evidenced in this compact but attractive kitchen.' },
  //   { id: 4, name: 'Bathrooms', image: '1_10' },
  //   { id: 5, name: 'Conversion', image: '2_0' },
  //   { id: 6, name: 'Orangeries', image: '022a' }
  // ]

  selectedCat: PortfolioCategory;
  
  constructor(
    private route: ActivatedRoute,
    // private location: Location
    private service: PortfolioService
  ) { }

  ngOnInit(): void {
    this.id = +this.route.snapshot.paramMap.get('id');
    this.getCategories();
    this.selectedCat = this.portfolioCats.find(c => c.id == this.id); 
  }

  getCategories() {
    this.portfolioCats = this.service.getAll();
    return this.id === 0 && this.itemCount === 0 ? this.portfolioCats : this.portfolioCats.slice(0, this.itemCount);
  }
}
